<app-card [rounded]="!expanded$" [class.h-full]="expanded$" [class.overflow-y-hidden]="expanded$" class="block cursor-pointer rounded-lg">
  <div header (click)="toggleExpanded()" class="flex justify-between rounded">
    <ng-content select="[header]"></ng-content>
    <div class="flex items-center">
      <app-icon [icon]="expanded$ ? 'chevron-up' : 'chevron-down'" width="w-3" height="h-3"></app-icon>
    </div>
  </div>
  @if (expanded$) {
    <div body [style.height]="expanded$ ? '100%' : '0'">
      <ng-content select="[body]"></ng-content>
    </div>
  }
</app-card>
